module.exports = __webpack_public_path__ + "static/assets/2e2faaf5753ac5ae1df6153ea2daf683.svg";